import { render, staticRenderFns } from "./EvolucaoReceita.vue?vue&type=template&id=bd8443fa&"
import script from "./EvolucaoReceita.vue?vue&type=script&lang=js&"
export * from "./EvolucaoReceita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports